let promise;
let My2c2pObj;

// export function getMy2c2p() {
//   promise ||
//     (promise = new Promise((resolve, reject) => {
//       const script = document.createElement("script");
//       script.src =
//         "https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/api/my2c2p.1.6.9.min.js";
//       //script.async = true;
//       script.onload = () => {
//         resolve(My2c2p);
//       };
//       script.onerror = () => {
//         reject();
//       };
//       document.body.appendChild(script);
//     }));
//   return promise;
// }

import { CC2P_URL } from "../libs/config";

export function getMy2c2p() {
  return new Promise((resolve, reject) => {
    if (!My2c2pObj) {
      const script = document.createElement("script");
      script.src = CC2P_URL;
      //script.async = true;
      script.onload = () => {
        My2c2pObj = My2c2p;
        resolve(My2c2pObj);
      };
      script.onerror = () => {
        reject();
      };
      document.body.appendChild(script);
    } else {
      resolve(My2c2pObj);
    }
  });
}

export function loadMy2c2() {
  const script = document.createElement("script");
  script.src = CC2P_URL;
  //script.async = true;
  script.onload = () => {
    My2c2pObj = My2c2p;
  };
  document.body.appendChild(script);
}
export default My2c2pObj;
